import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchRevenue } from '../../api/revenueApi';
import {
  FETCH_REVENUE_REQUEST,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_FAILURE,
} from '../constants/revenueConstants';

function* fetchRevenueSaga(action) {
  try {
    const response = yield call(fetchRevenue, action.payload);
    yield put({ type: FETCH_REVENUE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({
      type: FETCH_REVENUE_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
}

function* revenueSaga() {
  yield takeEvery(FETCH_REVENUE_REQUEST, fetchRevenueSaga);
}

export default revenueSaga;